import { Flex, LoadingIcon } from '@cash-design-system/react'
import { FlowContextProps, useFlowContext } from '@cash-web/shared-flow-data-access-context'
import { useExecuteOnce } from '@cash-web/shared-util-execute-once'

export const FlowExecuteOnce = ({ onExecute }: { onExecute: (flow: FlowContextProps) => void }) => {
  const flow = useFlowContext()

  useExecuteOnce(async () => {
    onExecute(flow)
  })

  return (
    <Flex justifyContent="center">
      <LoadingIcon />
    </Flex>
  )
}
